module.exports = __webpack_public_path__ + "img/logo-title.0ffa4ab7.png";